import { apiRequest } from '@/core';
import { type Match } from '@/slices/matches/types';

export const fetchDailyMatchesRequest = async (date: string) =>
  apiRequest<Match[]>({
    endpoint: `api/matches/daily/${date}`,
  });
